/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'exit': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M768 640V512H448V384h320V256l192 192zm-64-64v256H384v192L0 832V0h704v320h-64V64H128l256 128v576h256V576z"/>'
  }
})
